import { EntityModel } from '@/interfaces'
import {
  ALL_ESIM_SETTINGS_QUERY,
  CREATE_ESIM_SETTINGS_MUTATION,
  DELETE_ESIM_SETTINGS_MUTATION,
  FORCE_DELETE_ESIM_SETTINGS_MUTATION,
  SINGLE_ESIM_SETTINGS_QUERY,
  UPDATE_ESIM_SETTINGS_MUTATION,
} from './graphql'
import ratioEsimRegionEntity from '@/entities/ratioEsimRegion/entity'

const travelEsimSettingsModel: EntityModel = {
  name: 'esimSettings',
  namePlural: 'esimSettings',
  uniqueName: 'travelEsimSettings',
  uniqueNamePlural: 'travelEsimSettings',
  path: 'travel/pricing/esim_settings',
  baseUrl: '/travel/pricing/esim_settings',
  translationPrefix: 'entities:travelEsimSettings.',
  getDisplayName: (values: any) => {
    return 'ESIM SETTINGS'
  },
  gql: {
    getAll: ALL_ESIM_SETTINGS_QUERY,
    getSingle: SINGLE_ESIM_SETTINGS_QUERY,
    create: CREATE_ESIM_SETTINGS_MUTATION,
    update: UPDATE_ESIM_SETTINGS_MUTATION,
    delete: DELETE_ESIM_SETTINGS_MUTATION,
    forceDelete: FORCE_DELETE_ESIM_SETTINGS_MUTATION,
  },
  attributes: {
    enabled: {
      name: 'enabled',
      label: 'entities:travelEsimSettings.attributes.enabled.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    regions: {
      name: 'regions',
      label: 'entities:travelEsimSettings.attributes.regions.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return ratioEsimRegionEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default travelEsimSettingsModel
